import Marquee from "react-fast-marquee";
import { BRANDS } from "../lib/prestations";

export default function BrandMarquee({ category, label = "Nous intervenons sur toutes les grandes marques" }) {
  const brands = BRANDS[category] || [];
  if (!brands.length) return null;
  return (
    <div data-testid="brand-marquee" className="border-y border-slate-200 bg-slate-50 py-7">
      {label && (
        <p className="text-center text-xs font-semibold uppercase tracking-[0.14em] text-ink-muted mb-5">
          {label}
        </p>
      )}
      <Marquee speed={38} gradient gradientColor="#F8FAFC" gradientWidth={70} pauseOnHover autoFill>
        {brands.map((b, i) => (
          <div
            key={i}
            className="mx-3 flex items-center gap-3 bg-white rounded-xl border border-slate-200 shadow-sm pl-2 pr-5 py-2 whitespace-nowrap"
          >
            <span
              className="h-9 w-9 rounded-lg flex items-center justify-center text-white font-display font-extrabold text-lg"
              style={{ backgroundColor: b.color }}
            >
              {b.name.charAt(0)}
            </span>
            <span className="font-display font-bold text-ink text-base" style={{ color: b.color }}>
              {b.name}
            </span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
